import { Badge } from "@/components/ui/badge";

// Cosmetic tone hints for the seeded values; unknown (admin-added) values fall back
// to neutral styling — values themselves always come from Master Data.
const STAGE_TONES = {
  Applied: "bg-blue-50 text-blue-700 border-blue-200",
  Screening: "bg-amber-50 text-amber-700 border-amber-200",
  Interested: "bg-teal-50 text-teal-700 border-teal-200",
  "Interview Scheduled": "bg-violet-50 text-violet-700 border-violet-200",
  Going: "bg-indigo-50 text-indigo-700 border-indigo-200",
  Selected: "bg-emerald-600 text-white border-emerald-600",
  Rejected: "bg-red-50 text-red-700 border-red-200",
  Cancelled: "bg-muted text-muted-foreground border-border",
  Closed: "bg-slate-100 text-slate-600 border-slate-200",
};

const PRIORITY_TONES = {
  Immediate: "bg-red-50 text-red-700 border-red-200",
  Today: "bg-amber-50 text-amber-700 border-amber-200",
  "This Week": "bg-blue-50 text-blue-700 border-blue-200",
  Planned: "bg-muted text-muted-foreground border-border",
};

export const StageBadge = ({ stage, className = "" }) => {
  if (!stage) return null;
  return (
    <Badge variant="outline" data-testid="stage-badge"
      className={`rounded-full font-medium whitespace-nowrap ${STAGE_TONES[stage] || "bg-muted text-foreground"} ${className}`}>
      {stage}
    </Badge>
  );
};

export const PriorityBadge = ({ priority, className = "" }) => {
  if (!priority) return null;
  return (
    <Badge variant="outline" data-testid="priority-badge"
      className={`rounded-full font-medium whitespace-nowrap ${PRIORITY_TONES[priority] || "bg-muted text-muted-foreground"} ${className}`}>
      {priority}
    </Badge>
  );
};
